// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import http from '../../http-common';
import { dispatch } from '../index';
// ----------------------------------------------------------------------

const initialState = {
    error: null,
    notificacao: [],
    notificacaoOneUser: [],
    totalNaoLida: 0,
    notificacaoSuccess: [],
    messageExpediteur: 0
};

const slice = createSlice({
    name: 'notificacao',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        getNotificacaosSuccess(state, action) {
            state.notificacaoSuccess = action.payload;
        },

        getNotificacaosCountNaoLida(state, action) {
            state.totalNaoLida = action.payload;
        },

        // GET NOTIFICATIONS
        getAllNotidicacao(state, action) {
            state.notificacao = action.payload;
        },

        setNotificacaoUsuario1(state, action) {
            state.notificacaoOneUser = action.payload;
        },
        getMessageExpediteur(state, action) {
            state.messageExpediteur = action.payload;
        },

        setTotalNaoLida(state, action) {
            state.totalNaoLida = action.payload;
          },
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function setNotificationValue(value) {
    return async () => {
      try {  
        dispatch(slice.actions.setTotalNaoLida(value));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }

export function setNotificacaoUsuario(data) {
    return async () => {
        try {
            dispatch(slice.actions.setNotificacaoUsuario1(data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function getAllNotificacao(tipoPesquisa, universityID, usuarioID,
    messageExpediteur) {
    return async () => {
        try {
            const response = await http.get(`/notificacoesUsuario?tipoPesquisa=${tipoPesquisa}&universityID=${universityID}&usuarioID=${usuarioID}`);
             dispatch(slice.actions.getAllNotidicacao(response.data));
             
             dispatch(slice.actions.getMessageExpediteur(messageExpediteur)); // savoir qui a envoyé le message: Pour dire expediteur ou envoyém à

            } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function notificacaoUpdateLida(idNotificacao, idNotificacaoOriginal,respostaMensagem ) {
    return async () => {
        try {

            const response = await http.put(`/notificacoesUsuario/${idNotificacao}/?respostaMensagem=${respostaMensagem}&idNotificacaoOriginal=${idNotificacaoOriginal}`);
            
            dispatch(slice.actions.getNotificacaosSuccess(true));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function notificacaoCountNaoLida(tipoPesquisa, universityID, usuarioID) {
    return async () => {
        try {
             const response = await http.get(`/notificacoesUsuario?tipoPesquisa=${tipoPesquisa}&universityID=${universityID}&usuarioID=${usuarioID}`);
            //  dispatch(slice.actions.getNotificacaosCountNaoLida(response.data[0].total_nao_lida));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function notificacaoGravarDados(data) {
    return async () => {
        try {
            const response = await http.post("/notificacoesUsuario", data);
           
            dispatch(slice.actions.getNotificacaosSuccess(response.data));
          
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getNotificacaoOneUser(id) {
    return async () => {
        try {
            const response = await http.get(`/notificacoesUsuario/${id}`);
           
            dispatch(slice.actions.setNotificacaoUsuario1(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


